<sabis-ngx-dialog scTitle="Update Permissions">

  <div modal-body>
    <!-- Restricted From -->
    <mat-card appearance="outlined" class="p-0">
      <mat-card-title class="">
        <div class="card-title-text">Specific Access</div>
        <mat-divider></mat-divider>
      </mat-card-title>
      <mat-card-content>

        <div class="feeback-access-options">
          <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedAccessOption">
            <mat-radio-button name="allowedTo" [value]="0">Allowed To All</mat-radio-button>
            <mat-radio-button name="restrictedFrom" [value]="1">Specific Access To</mat-radio-button>
          </mat-radio-group>
          <!-- restricted recruiters -->
          @if (selectedAccessOption === 1) {
            <sabis-combobox2 [(ngModel)]="selectedAllowedToRecruiterIds"
              [scItems]="allUsers" name="restrictedFrom" [scMultiple]="true" scValueField="itemId"
            scDisplayField="name"></sabis-combobox2>
          }
        </div>

      </mat-card-content>
    </mat-card>
  </div>


  <div modal-footer>
    <sabis-ngx-button (click)="onSaveButtonClick()">
      Save
    </sabis-ngx-button>
    <sabis-ngx-button (click)="onCancelButtonClick()">
      Cancel
    </sabis-ngx-button>
  </div>

</sabis-ngx-dialog>